A URL of an external apply form.

When this is provided, SEEK's Apply Form will be disabled and the candidate will link out to the supplied URL.
This requires that the hirer has an `HiringOrganizationApiCapabilities.applicationMethodCodes` that includes `ApplicationUri`.

This field has a maximum length of 500 characters.
